// @ts-check

import React from "react"
import IconWithTooltip from "../IconWithTooltip.molecule"

/**
 * @param {import("./ActionsCell.molecule.types").ActionsCellProps} props
 * @returns {JSX.Element | null}
 */

export function ActionsCell(props) {
  const {
    ctx,
    userIsAdmin,
    updatingTask,
    contextMenuRef,
    setContextMenuTarget,
  } = props
  const { row } = ctx

  if (updatingTask && updatingTask?.taskId === row.original.taskId) {
    return (
      <IconWithTooltip
        iconClassName="pi pi-spin pi-spinner"
        tooltipValue="Guardando cambios"
      />
    )
  }

  if (userIsAdmin && !row.getIsGrouped() && row.original.taskId) {
    return (
      <i
        className="pi pi-ellipsis-v text-xl cursor-pointer"
        onClick={(event) => {
          contextMenuRef?.current?.show(event)
          setContextMenuTarget(row.original)
        }}
      />
    )
  }

  return null
}
